import React, { useState } from 'react'
import assets from 'shared/assets'
import { isMobile } from 'shared/helpers'
import Wrapper from './styles'
import { Logo } from './styles'
import { Description } from './styles'
import { Binder } from './styles'
import { BackgroundClose } from './styles'

const Modal = () => {
  const [show, setShow] = useState(true);

  if(!show){
    return null;
  }

  return(
    <Wrapper>
      <BackgroundClose onClick={() => setShow(false)}/>
      <Binder>
        <Logo src={assets.logo} />
        <Description>
        Para conocer las historias del personal de salud que ha muerto durante la pandemia de Covid–19 en México, utiliza los filtros o mueve el cursor sobre las partículas.
        {
          isMobile() && (
            <>
              <br/>
              <br />
              Este interactivo se navega mejor <strong>en escritorio.</strong>
            </>
          )
        }
        </Description>
      </Binder>
    </Wrapper>
  )
}

export default Modal;